/**
 * Machine-readable error codes for the prescriptions API. The shared problem
 * details filter keeps only `detail`, so the server puts the code string in
 * the exception message and clients match on it. The web keeps the copy
 * shown for each code. Order of checks: 404 → 403 → 409 LOCKED → 409
 * VERSION → 422.
 */ /** HTTP 403: only the prescriber (the encounter's provider) may change it. */ "use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get CLINIC_PROFILE_MISSING () {
        return CLINIC_PROFILE_MISSING;
    },
    get MEDICATION_DANGEROUS_DRUG_UNSUPPORTED () {
        return MEDICATION_DANGEROUS_DRUG_UNSUPPORTED;
    },
    get PRESCRIBER_CREDENTIALS_MISSING () {
        return PRESCRIBER_CREDENTIALS_MISSING;
    },
    get PRESCRIBER_LICENSE_EXPIRED () {
        return PRESCRIBER_LICENSE_EXPIRED;
    },
    get PRESCRIPTION_ACK_REQUIRED () {
        return PRESCRIPTION_ACK_REQUIRED;
    },
    get PRESCRIPTION_ALLERGIES_CHANGED () {
        return PRESCRIPTION_ALLERGIES_CHANGED;
    },
    get PRESCRIPTION_ALLERGY_CONFLICT () {
        return PRESCRIPTION_ALLERGY_CONFLICT;
    },
    get PRESCRIPTION_BRANCH_REQUIRED () {
        return PRESCRIPTION_BRANCH_REQUIRED;
    },
    get PRESCRIPTION_EMPTY () {
        return PRESCRIPTION_EMPTY;
    },
    get PRESCRIPTION_ENCOUNTER_NOT_ELIGIBLE () {
        return PRESCRIPTION_ENCOUNTER_NOT_ELIGIBLE;
    },
    get PRESCRIPTION_LOCKED () {
        return PRESCRIPTION_LOCKED;
    },
    get PRESCRIPTION_MEDICATION_UNKNOWN () {
        return PRESCRIPTION_MEDICATION_UNKNOWN;
    },
    get PRESCRIPTION_NOT_PRESCRIBER () {
        return PRESCRIPTION_NOT_PRESCRIBER;
    },
    get PRESCRIPTION_VERSION_CONFLICT () {
        return PRESCRIPTION_VERSION_CONFLICT;
    }
});
const PRESCRIPTION_NOT_PRESCRIBER = 'PRESCRIPTION_NOT_PRESCRIBER';
const PRESCRIPTION_LOCKED = 'PRESCRIPTION_LOCKED';
const PRESCRIPTION_VERSION_CONFLICT = 'PRESCRIPTION_VERSION_CONFLICT';
const PRESCRIPTION_ALLERGIES_CHANGED = 'PRESCRIPTION_ALLERGIES_CHANGED';
const PRESCRIPTION_ALLERGY_CONFLICT = 'PRESCRIPTION_ALLERGY_CONFLICT';
const PRESCRIPTION_EMPTY = 'PRESCRIPTION_EMPTY';
const PRESCRIPTION_ACK_REQUIRED = 'PRESCRIPTION_ACK_REQUIRED';
const PRESCRIBER_CREDENTIALS_MISSING = 'PRESCRIBER_CREDENTIALS_MISSING';
const PRESCRIBER_LICENSE_EXPIRED = 'PRESCRIBER_LICENSE_EXPIRED';
const CLINIC_PROFILE_MISSING = 'CLINIC_PROFILE_MISSING';
const PRESCRIPTION_BRANCH_REQUIRED = 'PRESCRIPTION_BRANCH_REQUIRED';
const MEDICATION_DANGEROUS_DRUG_UNSUPPORTED = 'MEDICATION_DANGEROUS_DRUG_UNSUPPORTED';
const PRESCRIPTION_MEDICATION_UNKNOWN = 'PRESCRIPTION_MEDICATION_UNKNOWN';
const PRESCRIPTION_ENCOUNTER_NOT_ELIGIBLE = 'PRESCRIPTION_ENCOUNTER_NOT_ELIGIBLE';
